import React from "react";
import HomeBanner from "../../../../components/sections/front/HomeBanner";
import HomeEvent from "../../../../components/sections/front/HomeEvent";
import HowItWorks from "../../../../components/sections/front/HowItWorks";
import Testimonial from "../../../../components/sections/front/Testimonial";
import CallToAction from "../../../../components/sections/front/CallToAction";
import Faq from "../../../../components/sections/front/Faq";
import Showcase from "../../../../components/sections/front/Showcase";

const Home = () => {
  return (
    <>
      <HomeBanner />
      <HomeEvent />
      <HowItWorks />
      <Testimonial />
      <Showcase />
      <Faq />
      <CallToAction />
    </>
  );
};

export default Home;
